
export function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

